export default "__VITE_ASSET__DVDKamdy__"